import React from 'react';
import Helmet from 'react-helmet';

export { withMetaDescription } from 'components/HeadProvider/withMetaDescription';

const HeadProvider = () => (
  <Helmet defaultTitle="deeptrue" titleTemplate="deeptrue - %s">
    <meta name="description" content="deeptrue" />
    <meta property="og:type" content="website" />
    <meta property="og:title" content="deeptrue" />
    <meta property="og:description" content="deeptrue" />
  </Helmet>
);

export default {
  Provider: HeadProvider,
  Head: Helmet,
};
